import { jsx as _jsx } from "react/jsx-runtime";
import { CloudUpload, Folder, Upload } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const FileEmptyState = ({ onAddFile }) => {
    return (_jsx(EmptyState, { backgroundIcon: Folder, primaryIcon: CloudUpload, accentIcon: Upload, title: "No Files Yet", description: "Get started by uploading your first file. This will help you manage and organize your documents in one place.", action: onAddFile
            ? { label: "Upload File", onClick: onAddFile }
            : undefined }));
};
